import { Switch, Route } from 'react-router'
import { BaseRoute } from 'Components'
import { useRouteMatch } from 'react-router'

import List from './List'
import New from './New'

export default ->

  { path } = useRouteMatch()

  <>
    <Switch>
      <Route path="#{ path }/new"><New /></Route>
      <Route exact><List /></Route>
    </Switch>
  </>
